export default function ({state, commit, dispatch, getters}, value) {
    commit('loading', true);
    dispatch('settings/get', {
        cb: () => {
            commit('loading', false);
        }
    })
}